import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { server } from "./configs";
import Axios from "axios";
import Swal from "sweetalert2";
import App from "./App";
import Auth from "./Auth";
import Version from "./screens/Version";
import NoToken from "./NoToken";
import Loading from "./components/Loading";
import VersionBase64 from "./screens/VersionBase64";

function Login({ match, history }) {
  const token = match ? match.params.tokenCode : null;
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (token) {
      Axios.post(server + "/login", {
        username: token,
        password: token,
      })
        .then(({ headers, status }) => {
          if (token !== localStorage.getItem("token")) {
            localStorage.clear();
            localStorage.setItem("jwt", headers.authorization);
            localStorage.setItem("token", token);
          }
          setIsLoaded(true);

          // console.log(status);
        })
        .catch((e) => {
          console.log(e);
          let errorMsg = "";

          if (e.response.status === 401) {
            errorMsg = "만료된 사용자입니다.";
          } else if (e.response.status === 403) {
            errorMsg = "이미 조사가 종료되었습니다.";
          } else if (e.response.status === 404) {
            errorMsg = "잘못된 파라미터이거나 없는 값입니다.";
          } else if (e.response.status === 500) {
            errorMsg =
              "서버 문제가 발생했습니다. 관리자에게 연락 부탁드립니다.";
          }

          if (
            e.response.status === 401 ||
            e.response.status === 403 ||
            e.response.status === 404 ||
            e.response.status === 500
          ) {
            localStorage.removeItem("jwt");
            localStorage.removeItem("token");
            Swal.fire({
              title: "에러",
              confirmButtonText: "닫기",
              confirmButtonColor: "#00aeef",
              text: errorMsg,
              heightAuto: false,
            });
          }

          history.push("/noToken");
        });
    } else {
      setIsLoaded(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return !isLoaded ? (
    <Loading />
  ) : (
    <Switch>
      <Route path="/token/:tokenCode" render={(match) => <App {...match} />} />
      {/* <Route
        path="/v2/:gov/:index"
        render={(match) => <Version {...match} {...history} />}
      /> */}
      <Route
          path="/v3/:base"
          render={(match) => <VersionBase64 {...match} {...history} />}
      />
      <Route path="/:urlcode" component={Auth} />
      <NoToken />
    </Switch>
  );
}
export default Login;
